import { EdgeLoadOrgStatusRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadOrgStatus } from '@/modules/auth/use-cases'

export function makeLoadOrgStatus(): LoadOrgStatus {
  return new EdgeLoadOrgStatusRepository(makeSupabaseEdgeHttpClient()).execute
}
